import React from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SmartphoneIcon from '@mui/icons-material/Smartphone';

export default function PaymentMethodTabs({ methods, selected, onSelect }) {
    // Filtramos para mostrar solo los automatizados
    const automatedMethods = methods.filter(m => 
        m.name === 'Stripe' || m.name === 'Pago Movil'
    );

    const handleChange = (event, newValue) => {
        const method = automatedMethods[newValue];
        onSelect(method);
    };

    // Encontrar el índice del método seleccionado para el Tab
    const selectedIndex = selected 
        ? automatedMethods.findIndex(m => m.id === selected.id) 
        : false;

    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs value={selectedIndex !== -1 ? selectedIndex : 0} onChange={handleChange} centered>
                {automatedMethods.map((method) => (
                    <Tab 
                        key={method.id} 
                        icon={method.name === 'Stripe' ? <CreditCardIcon /> : <SmartphoneIcon />}
                        label={method.name === 'Stripe' ? 'Tarjeta (Internacional)' : 'Pago Móvil (Bs)'} 
                    />
                ))}
            </Tabs>
        </Box>
    );
}